const SIGNUP_ACCESS_TOKEN_KEY = 'SIGNUP_ACCESS_TOKEN_KEY';

export {
  SIGNUP_ACCESS_TOKEN_KEY
};
